module.exports = __webpack_public_path__ + "static/five-3a86b491946dbd400880e549829f765f.png";